
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 104 104"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"52","cy":"52","r":"52","fill":"currentColor"}}),_c('path',{attrs:{"d":"M75.171 24H33.707a5.58 5.58 0 00-5.587 5.561v44.878a4.161 4.161 0 01-4.169 4.144.709.709 0 100 1.417h41.464A5.58 5.58 0 0071 74.439V29.561a4.169 4.169 0 018.338 0v2.93h-6.607v1.417h8.027v-4.347A5.58 5.58 0 0075.171 24zm-5.587 5.561v44.878a4.161 4.161 0 01-4.169 4.144H27.673a5.537 5.537 0 001.865-4.144V29.561a4.161 4.161 0 014.169-4.144h37.742a5.537 5.537 0 00-1.865 4.144z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M53.22 40.981h8.536v1.417H53.22zm0-6.064h8.536v1.417H53.22zM36.146 50.685h25.609v1.417H36.146zm0 6.065h25.609v1.417H36.146zm0 6.064h17.073v1.417H36.146zm1.929-18.698c0-1.019 2.855-2.93 5.389-2.93s5.388 1.911 5.388 2.93v2.426h1.418v-2.426c0-1.538-1.91-3.05-4.053-3.82a3.6 3.6 0 001.614-2.876v-2.377c0-2.041-2-3.765-4.367-3.765S39.1 33 39.1 35.043v2.377a3.6 3.6 0 001.61 2.88c-2.143.77-4.053 2.282-4.053 3.82v2.426h1.418zm2.439-6.7v-2.373c0-1.229 1.406-2.348 2.95-2.348s2.949 1.119 2.949 2.348v2.377c0 1.229-1.4 2.349-2.949 2.349s-2.95-1.12-2.95-2.349z","fill":"currentColor"}})])
          )
        }
      }
    